import { render, staticRenderFns } from "./RejectForm.vue?vue&type=template&id=974b9390"
import script from "./RejectForm.vue?vue&type=script&lang=js"
export * from "./RejectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports